import Modal from '@Components/Shared/Modals/Modal';
import {useEffect } from 'react';

const QuoteConfirmationModal = (props) => {

    useEffect(() => {
        const timer = setTimeout(() => {
            props.toggleConfirmationModal();
        }, 3000);
        return () => clearTimeout(timer);
    }, []);
   
    return (
        <Modal containerClassName='alert-modal' onEscapeKeyClose={props.onClose}>
            <Modal.Header onClose={props.onClose}>
                <div className="top-row">
                    <Modal.Title headingClassName='show-all-modal-title'>
                        {props.title}
                    </Modal.Title></div>
            </Modal.Header>
            <Modal.Body>
                <p id='description-label' className='hidden'>{props.message}</p>
                <p>{props.message}</p>
            </Modal.Body>
        </Modal>
    );
}

export default QuoteConfirmationModal;